<template>
  <Layout>
    <div v-if="aupairs && aupairs.length > 0">
      <h2 class="page-title mb-5">Your favorite Au Pairs</h2>

      <ul
        class="flex flex-col justify-start items-center sm:flex-row flex-wrap"
      >
        <li
          class="w-full md:w-1/2 sm:px-1"
          v-for="(aupair, index) in aupairs"
          :key="index"
        >
          <AuPairShortCard :aupair="aupair">
            <div
              class="-mx-3 p-1 flex items-center justify-around border-t border-purple-ap-t03"
            >
              <span
                @click.prevent="addToComparison(aupair.auPairPromoProfileId)"
              >
                <ToggleChecked
                  v-if="
                    findElementInObject(
                      comparison,
                      'auPairPromoProfileId',
                      aupair.auPairPromoProfileId
                    )
                  "
                />
                <ToggleUnchecked v-else />
              </span>

              <router-link
                class="text-sm"
                tag="a"
                :to="{
                  name: 'Profile',
                  params: { id: aupair.auPairPromoProfileId },
                }"
                >View Profile</router-link
              >
            </div>

            <div
              v-if="!isMatched"
              class="-mx-3 flex items-center justify-around border-b border-purple-ap-t03"
            >
              <button
                v-if="
                  !findElement(getRequestInterview, aupair.auPairPromoProfileId)
                "
                @click.prevent="requestInterview(aupair)"
                class="btn text-sm uppercase rounded-none btn-purple w-full"
              >
                Request Interview
              </button>
            </div>
          </AuPairShortCard>
        </li>
      </ul>
    </div>
    <ComponentLoading v-else />
    <Comparison :aupairs="this.aupairs" :list="comparison" />
  </Layout>
</template>

<script>
import { api } from "@/services.js";

import Layout from "@/Layout/Authenticated/Layout.vue";
import AuPairShortCard from "@/components/AuPairs/AuPairShortCard.vue";
import Comparison from "@/components/AuPairs/FavoriteAuPairsItems/Comparison.vue";
import ToggleUnchecked from "@/components/UI/Toggle/ToggleUnchecked.vue";
import ToggleChecked from "@/components/UI/Toggle/ToggleChecked.vue";

export default {
  name: "FavoriteAuPairs",
  components: {
    Layout,
    AuPairShortCard,
    Comparison,
    ToggleUnchecked,
    ToggleChecked,
  },
  data() {
    return {
      aupairs: null,
      comparison: [],
      comparisonLimit: 4,
    };
  },
  computed: {
    getRequestInterview() {
      return this.$store.state.user.requestInterview;
    },
    isMatched() {
      return this.$store.state.user.matchRequest ? true : false;
    },
  },
  created() {
    if (this.$store.state.user.match) {
      this.$router.push({
        name: "Home",
      });
    } else {
      this.pullData();
    }
  },
  methods: {
    pullData() {
      api.get("/promotional/AuPairPromoProfiles/favorites").then((r) => {
        this.aupairs = r.data;
        if (this.aupairs && this.aupairs.length == 0) {
          this.$router.push({
            name: "AvailableAuPairs",
          });
          this.$toasted.global.notificate({
            message: "You have no favorite Au Pairs, redirecting...",
            type: "info",
          });
        }
        this.suggested = r.data.suggested;
      });
    },

    addToComparison(id) {
      let apObj = this.findElementInObject(
        this.aupairs,
        "auPairPromoProfileId",
        id
      );
      this.toggleComparison(apObj);
    },
    requestInterview(aupair) {
      this.$router.push({
        name: "InterviewConfirmation",
        params: { aupair: aupair },
      });
    },
    //adds/removes an au pair object from the comparison list
    toggleComparison(apObj) {
      let index = this.comparison.indexOf(apObj);
      if (index === -1) {
        if (this.comparison.length < this.comparisonLimit) {
          this.comparison.push(apObj);
        } else {
          this.$toasted.global.notificate({
            message: "You can only compare up to 4 Au Pairs at a time.",
            type: "error",
          });
        }
      } else {
        this.comparison.splice(index, 1);
      }
    },

    findElementInObject(arr, propName, propValue) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i][propName] == propValue) return arr[i];
      }
      return false;
    },
    findElement(arr, propValue) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] == propValue) return arr[i];
      }
      return false;
    },
  },
};
</script>
